import { render } from "./MotorradPage.vue?vue&type=template&id=8154ddd6"
import script from "./MotorradPage.vue?vue&type=script&lang=js"
export * from "./MotorradPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__